import { useAuth } from '@clerk/clerk-react'
import { Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface AuthLayoutProps {
  redirectTo?: string
}

export function AuthLayout({ redirectTo = '/sign-in' }: AuthLayoutProps) {
  const { isLoaded, isSignedIn } = useAuth()
  const { t } = useTranslation()

  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
          <p className="mt-2 text-sm text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to={redirectTo} replace />
  }

  return <Outlet />
}